module.exports = __webpack_public_path__ + "static/6-962b56be6673f0ecfb5aef616de18ae4.jpeg";